import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { RoyalDecreeService } from "../../core/services/royal-decree.service";
import { CommonService } from "src/app/core/services/common.service";
import { CampoValorLI, FieldAvailable } from "../models/availablefields.model";
import { ListValueService } from "src/app/core/services/list-value.service";

@Component({
  selector: "app-available-fields",
  templateUrl: "./available-fields.component.html",
  styleUrls: ["./available-fields.component.css"],
})
export class AvailableFieldsComponent implements OnInit {
  fieldsAvailable: FormGroup;
  fieldLI: FormGroup;
  operation: string;
  routing = RoutingConstants.royalDecreeRouting;
  file: any;

  public types: string[] = [
    "ACC",
    "STRING",
    "BOOL",
    "DBLIST",
    "FILE",
    "INT",
    "LIST",
    "LITERAL",
    "TEXTAREA",
  ];

  public dbLists: string[] = [
    "CATEGORIAS",
    "CLASIFICACIONES",
    "INDICE_CARGA",
    "INDICE_VELOCIDAD",
    "MOTIVO_REEDICION",
    "NEUMATICO_ANCHO",
    "NEUMATICO_BOMBEO",
    "NEUMATICO_DIAMETRO",
    "NEUMATICO_GARGANTA",
    "NEUMATICO_PERFIL",
    "TCAMBIO_DENOM",
    "TCAMBIO_SIGLA",
    "TMOTOR",
    "TPLACA",
  ];

  public listaCampoValor: CampoValorLI[];
  public allSelected: boolean = false;

  constructor(
    private toastrAlertService: ToastrAlertService,
    private royalDecreeService: RoyalDecreeService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private listValueService: ListValueService
  ) {}

  ngOnInit(): void {
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.initFormGroup();
    this.getAvailableField();
  }

  initFormGroup() {
    this.fieldsAvailable = new FormGroup({
      cdId: new FormControl("", [
        Validators.required,
        Validators.maxLength(32),
      ]),
      cdAyuda: new FormControl(null),
      cdListadb: new FormControl(""),
      cdLongitud: new FormControl("", [
        Validators.required,
        Validators.max(256),
      ]),
      cdTexto: new FormControl("", Validators.maxLength(128)),
      cdTipo: new FormControl("", [
        Validators.required,
        Validators.maxLength(8),
      ]),
      valor: new FormControl(""),
    });
  }

  setValues(data: FieldAvailable) {
    this.fieldsAvailable.patchValue({
      cdId: data.cdId,
      cdAyuda: data.cdAyuda,
      cdListadb: data.cdListadb,
      cdLongitud: data.cdLongitud,
      cdTexto: data.cdTexto,
      cdTipo: data.cdTipo,
    });
    if (data.cdTipo === "LIST") {
      this.loadFieldsLI(data.cdId);
    }
    if (this.operation === "edicion") this.onChangeTipo();
  }

  getAvailableField() {
    if (this.activatedRoute.snapshot.params.id) {
      let id = this.activatedRoute.snapshot.params.id;
      this.royalDecreeService.getOneFieldAvailable(id).subscribe(
        (data) => {
          this.setValues(data);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  onUpdate() {
    let value: FieldAvailable = {
      cdId: this.fieldsAvailable.value.cdId,
      cdAyuda: this.fieldsAvailable.value.cdAyuda,
      cdListadb: this.fieldsAvailable.value.cdListadb,
      cdLongitud: this.fieldsAvailable.value.cdLongitud,
      cdTexto: this.fieldsAvailable.value.cdTexto,
      cdTipo: this.fieldsAvailable.value.cdTipo,
    };
    this.royalDecreeService.updateFieldAvailable(value, this.file).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(
          data["mensaje"],
          this.routing.list
        );
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onCreate() {
    let value: FieldAvailable = {
      cdId: this.fieldsAvailable.value.cdId,
      cdAyuda: this.fieldsAvailable.value.cdAyuda,
      cdListadb: this.fieldsAvailable.value.cdListadb,
      cdLongitud: this.fieldsAvailable.value.cdLongitud,
      cdTexto: this.fieldsAvailable.value.cdTexto,
      cdTipo: this.fieldsAvailable.value.cdTipo,
    };
    this.royalDecreeService.createFieldAvailable(value, this.file).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(
          data["mensaje"],
          this.routing.list
        );
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  onSave() {
    if (
      this.fieldsAvailable.value.cdTipo == "DBLIST" ||
      this.fieldsAvailable.value.cdTipo == "BOOL" ||
      this.fieldsAvailable.value.cdTipo == "LIST" ||
      this.fieldsAvailable.value.cdTipo == "FILE" ||
      this.fieldsAvailable.value.cdTipo == "LITERAL"
    ) {
      this.fieldsAvailable.patchValue({
        cdLongitud: 1,
      });
    }
    let invalidFields = this.commonService.findInvalidControls(
      this.fieldsAvailable.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.operation === "edicion") {
        this.onUpdate();
      } else if (this.operation === "creacion") {
        this.onCreate();
      }
    }
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  handleFileInput(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.fieldsAvailable.value.cdTexto = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.file = this.commonService.castToBlob(e.target.result);
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  public onChangeTipo() {
    if (this.fieldsAvailable.value.cdTipo === "DBLIST") {
      this.fieldsAvailable
        .get("cdListadb")
        ?.setValidators([Validators.required]);
      this.fieldsAvailable.get("cdLongitud")?.clearValidators();
    } else if (
      this.fieldsAvailable.value.cdTipo == "LIST" &&
      this.operation == "edicion"
    ) {
      this.fieldsAvailable.get("cdLongitud")?.clearValidators();
      this.fieldsAvailable.get("cdListadb")?.clearValidators();
    } else if (
      !(
        this.fieldsAvailable.value.cdTipo == "DBLIST" ||
        this.fieldsAvailable.value.cdTipo == "BOOL" ||
        this.fieldsAvailable.value.cdTipo == "LIST" ||
        this.fieldsAvailable.value.cdTipo == "FILE" ||
        this.fieldsAvailable.value.cdTipo == "LITERAL"
      )
    ) {
      this.fieldsAvailable
        .get("cdLongitud")
        ?.setValidators([Validators.required, Validators.max(256)]);

      this.fieldsAvailable.get("cdListadb")?.clearValidators();
    } else {
      this.fieldsAvailable.get("cdListadb")?.clearValidators();
      this.fieldsAvailable.get("cdLongitud")?.clearValidators();
    }

    this.fieldsAvailable.get("cdLongitud")?.updateValueAndValidity();
    this.fieldsAvailable.get("cdListadb")?.updateValueAndValidity();
  }

  public submitLI() {
    if (
      !this.fieldsAvailable.value.valor ||
      this.fieldsAvailable.value.valor == ""
    ) {
      this.toastrAlertService.toastrFail(
        "El campo valor a introducir es requerido"
      );
    } else if (this.fieldsAvailable.value.valor.length > 128) {
      this.toastrAlertService.toastrFail(
        "El campo valor a introducir ha excedido el tamaño máximo de 128 caracteres"
      );
    } else {
      this.createLI();
    }
  }

  private createLI() {
    let value: CampoValorLI = {
      campoId: this.fieldsAvailable.value.cdId,
      valor: this.fieldsAvailable.value.valor,
    };
    this.royalDecreeService.createCampoValorLI(value).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data["mensaje"]);
        this.fieldsAvailable.patchValue({
          valor: "",
        });
        this.loadFieldsLI(value.campoId);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public removeLI() {
    let arrayIds: CampoValorLI[] = [];
    this.listaCampoValor.filter((e) => {
      if (e.checked) {
        arrayIds.push(e);
      }
    });
    if (arrayIds.length == 0) {
      this.toastrAlertService.toastrFail(
        "Debe seleccionar algún elemento de la lista para eliminarlo"
      );
    } else {
      let dto = { dto: arrayIds };
      this.royalDecreeService.removeCampoValorLI(dto).subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data["mensaje"]);
          this.loadFieldsLI(this.fieldsAvailable.value.cdId);
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  private loadFieldsLI(cdId: string) {
    this.listValueService.listCamposLI(cdId).subscribe(
      (data) => {
        this.listaCampoValor = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public selectItem(item: any) {
    if (item == "all") {
      this.allSelected = this.allSelected ? false : true;
      if (this.allSelected) {
        this.listaCampoValor.filter((e) => {
          e.checked = true;
        });
      } else {
        this.listaCampoValor.filter((e) => {
          e.checked = false;
        });
      }
    } else {
      item.checked = item.checked ? false : true;
      const checkedAll = (e) => e.checked == false || !e.checked;
      if (this.listaCampoValor.some(checkedAll)) {
        this.allSelected = false;
      } else {
        this.allSelected = true;
      }
    }
  }

  public setNumber() {
    if (this.fieldsAvailable.value.cdLongitud < 0) {
      this.fieldsAvailable.patchValue({
        cdLongitud: 1,
      });
    }
  }
}
